import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { Entity } from '../select-list/select-list.component';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {
  public title : string;
  constructor(public api : ApiService) 
  {
    this.selectedItems = [];
  }

  ngOnInit() {
  }

  get items(){
    return this.api.session.projects;
  }

  get selectedItems(){
    return this.api.session.currentCriteria.projects.selectedItems;
  }
  set selectedItems(value){
    MyUtility.scrubChildren(value);
    this.api.session.currentCriteria.projects.selectedItems = value;
  }

  clearCurrent(){
    this.api.session.currentCriteria.projects = MyUtility.deepCopy(this.api.originalCriteria.projects);
  }
}
